import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-h6" }, "Search for member", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_card = _resolveComponent("q-card")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_card, {
    class: "q-pa-md",
    style: {"min-width":"800px","min-height":"568px"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card_section, { class: "row items-center q-pb-none" }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_component_q_space),
          _withDirectives(_createVNode(_component_q_btn, {
            icon: "close",
            flat: "",
            round: "",
            dense: ""
          }, null, 512), [
            [_directive_close_popup]
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_q_card_section, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_input, {
            modelValue: _ctx.filter,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter) = $event)),
            "hide-bottom-space": "",
            "lazy-rules": "",
            label: "Type name or email to search for existing users",
            type: "email",
            clearable: "",
            outlined: "",
            dense: ""
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      (_ctx.members)
        ? (_openBlock(), _createBlock(_component_q_card_section, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_q_table, {
                columns: _ctx.searchForMemberColumns,
                rows: _ctx.members,
                "row-key": "name",
                filter: _ctx.filter,
                pagination: _ctx.pagination,
                "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pagination) = $event)),
                onRequest: _ctx.onRequest,
                loading: _ctx.loading,
                flat: ""
              }, {
                "body-cell-actions": _withCtx((props) => [
                  _createVNode(_component_q_td, { props: props }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_btn, {
                        label: "Pick",
                        unelevated: "",
                        "no-caps": "",
                        color: "primary",
                        onClick: ($event: any) => (_ctx.pickMember(props.row))
                      }, null, 8, ["onClick"])
                    ]),
                    _: 2
                  }, 1032, ["props"])
                ]),
                _: 1
              }, 8, ["columns", "rows", "filter", "pagination", "onRequest", "loading"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}